module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-icon-A-doubled.13d09d7f.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-icon-A-doubled.png
// module id = 2510
// module chunks = 11